import React, { useState } from "react";
import { FiMail, FiX } from "react-icons/fi";
import api, { apiError } from "../../lib/api";
import RenderToast from "../../appcomponents/RenderToast";
import styles from "./ForgotPassword.module.css";

export default function ForgotPasswordModal({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const handleClose = () => {
    if (sending) return;
    setEmail("");
    onClose?.();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;

    if (!email.trim()) {
      RenderToast({ type: "error", message: "Email address is required." });
      return;
    }

    setSending(true);
    try {
      const response = await api.post("/api/auth/forgot-password.php", {
        email: email.trim(),
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || "Unable to send reset link.");
      }
      RenderToast({
        type: "success",
        message: response.data?.message || "If that email is registered, a reset link has been sent.",
      });
      setEmail("");
      onClose?.();
    } catch (err) {
      RenderToast({ type: "error", message: apiError(err) });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={styles.backdrop} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>Forgot Password</h3>
          <button type="button" className={styles.closeBtn} onClick={handleClose}>
            <FiX />
          </button>
        </div>
        <form className={styles.form} onSubmit={handleSubmit}>
          <p className={styles.hint}>
            Enter the email address linked to your account and we'll send you a link to reset your password.
          </p>
          <label>
            <span>Email Address</span>
            <div className={styles.inputWrap}>
              <FiMail className={styles.inputIcon} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                autoComplete="email"
              />
            </div>
          </label>
          <div className={styles.actions}>
            <button type="button" className={styles.secondaryBtn} onClick={handleClose} disabled={sending}>
              Cancel
            </button>
            <button type="submit" className={styles.primaryBtn} disabled={sending}>
              {sending ? "Sending..." : "Send Reset Link"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
